// extracted by mini-css-extract-plugin
module.exports = {"section":"TodoList__section--3ZaTe"};